<template>
  <b-modal v-model="visible" title="Nuevo Usuario">
    <b-row>
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-user"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input type="text" :placeholder="user.es_ejecutivo?'Codigo de Ejecutivo':'Codigo de Agente'" v-model="user.cod_ejecutivo"></b-form-input>
            <b-form-checkbox class="mt-2 ml-1" v-model="user.es_ejecutivo" @input="changeEjecutivo">Es Ejecutivo</b-form-checkbox>
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-user"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input type="text" placeholder="Nombre" v-model="user.name"></b-form-input>            
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-at"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input type="email" placeholder="Correo electrónico" v-model="user.email"></b-form-input>
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-key"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input type="password" placeholder="Contraseña" v-model="user.password"></b-form-input>
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-key"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input
              type="password"
              placeholder="Repita contraseña"
              v-model="user.password_confirmation"
            ></b-form-input>
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group>
          <b-input-group size="lg">
            <b-input-group-prepend>
              <span class="input-group-text">
                <i class="fa fa-tag"></i>
              </span>
            </b-input-group-prepend>
            <!--b-form-select :options="roles" placeholder="Rol" v-model="user.role"></b-form-select-->
            <v-select class="form-control p-0 h10" :options="roles" 
                        multiple 
                        v-model="user.role"                        
                        :disabled="user.cod_agente === 9999">
              </v-select>
          </b-input-group>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>      
      <b-col class="mt-2">
        <b-input-group>
          <b-form-checkbox v-if="!user.es_ejecutivo" class="mt-2 ml-1" v-model="user.factura" ><b>Habilitar Carga de Factura</b></b-form-checkbox>          
        </b-input-group>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="float-right" @click="submit">
          <i class="fa fa-check" v-if="!sending"></i>
          <i class="fa fa-spinner fa-spin" v-else></i>
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalNuevoUsuario',
  props: {
    roles: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      sending: false,
      user: {
        es_ejecutivo: false,
        cod_ejecutivo: null,
        role: 0,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        factura: true
      }
    };
  },
  methods: {
    changeEjecutivo(){
      this.user.factura = !this.user.es_ejecutivo;
    },
    toggle() {
      this.visible = !this.visible;
      this.user.factura = true;
    },
    submit: async function() {
      this.sending = true;           
      await this.$api
        .post('auth/usuario-interno', this.user)
        .then(response => {
          this.$toast.success(response.data);
          this.user = {
            es_ejecutivo: false,
            cod_ejecutivo: null,            
            role: [],
            name: '',
            email: '',
            password: '',
            password_confirmation: ''
          };

          this.$emit('change', this.user);
        })
        .catch(err => {
          this.sending = false;
          const errors = err.response.data.errors;
          const error = err.response.data;

          if (errors) {
            for (let index in errors) {
              for (let error of errors[index]) {
                this.$toast.error(error);
              }
            }
          }

          if (error) {
            this.$toast.error(error);
          }
        });

      this.sending = false;
    }
  }
};
</script>
    
